<template>
	<div v-if="show && unreadMessages.length > 0" class="page-notification">
		{{unreadMessages.length}} new {{pluralizeString}}

		<a href="#" @click.prevent.stop="loadNewMessages">Show</a>

		<a href="#" @click.prevent.stop="show = false">Ignore</a>

		<loading class="comments__loading" :visible="loading" />
	</div>
</template>

<script>
import { pluralize } from '../filters';
import Loading from '../components/Loading.vue';

export default {
	name: 'comments-notification',

	components: {
		Loading,
	},

	props: {
		unreadMessages: {
			required: true,
		},
	},

	data() {
		return {
			show: true,
			loading: false,
		};
	},

	computed: {
		isAdmin() {
			return window.is_admin;
		},
		pluralizeString() {
			return pluralize('message', this.unreadMessages.length)
		}
	},

	methods: {
		loadNewMessages() {
			this.loading = true;
			this.$emit('loadNewMessages');
		},
	},

	watch: {
		unreadMessages() {
			if (this.unreadMessages.length === 0) {
				this.loading = false;
			}
		},
	},
};
</script>
